var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import React, { useRef, useState } from "react";
import { Button, ButtonText, Container, HiddenInput, Icon, Item, List, ListContainer, } from "./DropDown.styles";
import chevron from "../assets/DropDown/Vector.png";
import { useField, useFormikContext } from "formik";
export var DropDown = function (_a) {
    var _b = _a.selected, selected = _b === void 0 ? "" : _b, _c = _a.data, data = _c === void 0 ? [] : _c, selectHandler = _a.selectHandler, color = _a.color, textInput = _a.textInput, height = _a.height, setFieldValue = _a.setFieldValue, props = __rest(_a, ["selected", "data", "selectHandler", "color", "textInput", "height", "setFieldValue"]);
    if (!setFieldValue)
        setFieldValue = useFormikContext().setFieldValue;
    var _d = __read(useField(props), 1), field = _d[0]; // add meta for error handling
    //default to first value in data array
    selected = field.value || selected;
    //if (!field.value) setFieldValue(field.name, selected);
    var _e = __read(useState(selected || data[0]), 2), value = _e[0], setValue = _e[1];
    var _f = __read(useState(false), 2), open = _f[0], setOpen = _f[1];
    var dropdown = useRef(null);
    var itemClickHandler = function (item) { return function (_event) {
        setValue(item);
        //if a handler is set pass the value out
        if (selectHandler)
            selectHandler(value);
        if (setFieldValue)
            setFieldValue(props.name, item);
        setOpen(false);
    }; };
    var buttonClickHandler = function (_event) {
        setOpen(!open);
    };
    //generic click handler for the document
    var handleClick = function (event) {
        if (dropdown.current) {
            //check if the drop down is open and not the target
            if (open &&
                event.target &&
                dropdown.current &&
                !dropdown.current.contains(event.target)) {
                //close dropdown
                setOpen(false);
            }
        }
    };
    React.useEffect(function () {
        document.addEventListener("click", handleClick);
        return function () { return document.removeEventListener("click", handleClick); };
    }, []);
    return (React.createElement(Container, { className: "dropdown", ref: dropdown },
        React.createElement(HiddenInput, __assign({}, field, { value: field.value || "" }, props)),
        React.createElement(Button, { type: "button", height: height, color: color, textInput: textInput, onClick: buttonClickHandler },
            React.createElement(ButtonText, null, value),
            React.createElement(Icon, { src: chevron })),
        open && (React.createElement(ListContainer, null,
            React.createElement(List, null, data.map(function (item) {
                if (item !== "") {
                    return (React.createElement(Item, { key: item, onClick: itemClickHandler(item) }, item));
                }
            }))))));
};
//# sourceMappingURL=DropDown.js.map